export default "__VITE_ASSET__Dx_d$fbO__"